<ng-container [ngSwitch]="step">
  <app-street-light-planner-step2
    *ngSwitchCase="2"
    [isBudget]="scenario.isBudget"
    [budget]="scenario.budget"
    [minPrice]="minPrice"
    [maxPrice]="maxPrice"
    (budgetChange)="scenario.budget = $event"
    (iSBudgetChange)="scenario.isBudget = $event"
  >
  </app-street-light-planner-step2>

  <app-street-light-planner-step3 *ngSwitchCase="3" [type]="scenario.recommendationTypeId" (typeSelectChange)="onTypeChange($event)">
  </app-street-light-planner-step3>
</ng-container>
